
export async function NetworkFetch(apiroute: any, body?: any) {

    const SERVER_URL = (window as any).ENV.SERVER_URL;
    const uri = SERVER_URL + apiroute.path;
    const TIMEOUT = 60000; // 60 segundos para mejorar compatibilidad en mobile

    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), TIMEOUT);

        const response = await fetch(uri, {
            method: apiroute.method,
            headers: {
                "Content-Type": "application/json",
            },
            body: body ? JSON.stringify(body) : undefined,
            signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
            const resp = await response.text();

            throw resp
        }

        const responseText = await response.text();

        try {
            return JSON.parse(responseText);
        } catch (error) {
            return responseText
        }

    } catch (error: any) {
        throw error
    }

}